import { Badge, Tooltip } from '@mantine/core';
import type { RunStatus } from '@prisma/client';

export default function RunStatusBadge({ status }: { status?: RunStatus }) {
  if (!status) {
    return (
      <Badge
        color="gray"
        variant="light"
        radius="sm"
      >
        Never ran
      </Badge>
    );
  }

  return (
    status === 'PASSED' ?
      <Badge
        color="green"
        variant="light"
        radius="sm"
      >
        PASSED
      </Badge>
    : status === 'SKIPPED' ?
      <Badge
        color="gray"
        variant="light"
        radius="sm"
      >
        SKIPPED
      </Badge>
    : status === 'FAILED' ?
      <Badge
        color="red"
        variant="light"
        radius="sm"
      >
        FAILED
      </Badge>
    : status === 'FLAKY' ?
      <Tooltip label="Passed after retry">
        <Badge
          color="yellow"
          variant="light"
          radius="sm"
        >
          FLAKY
        </Badge>
      </Tooltip>
    : status === 'RUNNING' ?
      <Badge
        color="blue"
        variant="light"
        radius="sm"
      >
        RUNNING
      </Badge>
    : status === 'CANCELLED' ?
      <Badge
        color="gray"
        variant="light"
        radius="sm"
      >
        CANCELLED
      </Badge>
    : <Badge
        color="gray"
        variant="light"
        radius="sm"
      >
        Never ran
      </Badge>
  );
}
